/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { ProfileDropdown } from "./dropdowns/profile-dropdown";
import "../styles/components/nav-bar.scss";
import Logo from "../images/crew_logo_white.png";
import Marking from "../images/marking.png";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faComment,
  faHardHat,
  faPencil,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
export const NavBar = ({ me, member, minimized, setMinimized }) => {
  const location = useLocation();
  let pathName = location.pathname;
  const [showLearn, setShowLearn] = useState(false);
  const [minimize, setMinimize] = useState(minimized);
  const history = useHistory();
  const [isInCrew, setIsInCrew] = useState(false);
  const [isCoach, setIsCoach] = useState(false);
  const [progamFinished, setProgramFinished] = useState(false);

  useEffect(() => {
    if (member.type === "partial") {
      setMinimize(true);
      setMinimized(true);
    }

    if (me?.crew.length > 0) {
      setIsInCrew(true);
      setProgramFinished(
        getFilteredSessions(me.crew[0].program.sessions).length === 0
      );
    } else {
      setIsInCrew(false);
    }

    const isCoachArray = me?.roles?.filter((role) => {
      return role.name === "Coach";
    });

    if (isCoachArray?.length > 0) {
      setIsCoach(true);
    }

    if (pathName.includes("/learn/")) {
      setShowLearn(true);
    } else {
      setShowLearn(false);
    }
  }, [pathName, me]);

  const getFilteredSessions = (sessions) => {
    const now = moment().startOf("day");

    if (!sessions) return [];

    const sortedSessions = sessions.sort((a, b) => {
      return moment(a.startDate).diff(moment(b.startDate));
    });

    return sortedSessions.filter((session) => {
      return moment(session.startDate).isAfter(now);
    });
  };

  if (member.type === "partial") {
    return (
      <div className={`nav-bar__container ${minimize ? "minimized" : ""}`}>
        <nav className="nav-bar">
          <div className="nav-bar__brand full">
            {!minimize && (
              <img
                className="nav-bar__logo"
                src={Logo}
                alt="Crew Logo"
                style={{
                  maxWidth: "100px",
                }}
              />
            )}
            {minimize && (
              <img
                className="nav-bar__logo"
                src={Marking}
                alt="Crew Logo"
                style={{
                  maxWidth: "100px",
                }}
              />
            )}
          </div>
          <ProfileDropdown />
        </nav>
      </div>
    );
  }

  return (
    <div
      onDoubleClick={() => {
        setMinimize(!minimize);
        setMinimized(!minimize);
      }}
      className={`nav-bar__container ${minimize ? "minimized" : ""}`}
    >
      <nav className="nav-bar">
        <div className="nav-bar__brand full">
          {!minimize && (
            <img
              className="nav-bar__logo"
              src={Logo}
              alt="Crew Logo"
              style={{
                maxWidth: "100px",
              }}
            />
          )}
          {minimize && (
            <img
              className="nav-bar__logo"
              src={Marking}
              alt="Crew Logo"
              style={{
                maxWidth: "100px",
              }}
            />
          )}
        </div>
        <div className="nav-bar__links">
          <NavLink
            isActive={() => {
              if (
                pathName === "/dashboard" ||
                pathName === "/" ||
                pathName === "/path/1/dashboard"
              ) {
                return true;
              }
              return false;
            }}
            className="link"
            to="/dashboard"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1_2148)">
                <path d="M17.17 19.55H6.83002V24H17.17V19.55Z" fill="#EE9B65" />
                <path
                  d="M1.92999 17.84L0.929991 18.84V22.84C0.92329 22.9866 0.94573 23.1331 0.996013 23.271C1.0463 23.4089 1.12342 23.5354 1.22293 23.6433C1.32244 23.7512 1.44235 23.8382 1.57574 23.8995C1.70912 23.9607 1.85332 23.9949 1.99999 24H5.32999V14.53L1.92999 17.84Z"
                  fill="#EE9B65"
                />
                <path
                  d="M23.12 22.89V11.12C23.12 10.973 23.0909 10.8275 23.0342 10.6919C22.9776 10.5563 22.8946 10.4333 22.79 10.33L16.28 3.82L13.07 7L18.67 12.47V24H22C22.1466 24.0013 22.292 23.9736 22.4279 23.9184C22.5637 23.8632 22.6872 23.7817 22.7914 23.6784C22.8955 23.5752 22.9782 23.4524 23.0346 23.3171C23.091 23.1818 23.12 23.0366 23.12 22.89Z"
                  fill="#EE9B65"
                />
                <path
                  d="M12 5.91L15.22 2.76L12.79 0.33C12.6868 0.225387 12.5637 0.142323 12.4281 0.0856303C12.2925 0.0289372 12.147 -0.000256538 12 -0.000256538C11.853 -0.000256538 11.7075 0.0289372 11.5719 0.0856303C11.4363 0.142323 11.3133 0.225387 11.21 0.33L1.21 10.33C1.10544 10.4333 1.02242 10.5563 0.965773 10.6919C0.909125 10.8275 0.879971 10.973 0.880005 11.12V16.77L5.33 12.43L12 5.91Z"
                  fill="#EE9B65"
                />
              </g>
              <defs>
                <clipPath id="clip0_1_2148">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span className="text">Home</span>
          </NavLink>

          {isInCrew && (
            <NavLink
              isActive={() => {
                if (pathName.includes("program")) {
                  return true;
                }
                return false;
              }}
              className="link"
              to="/program"
            >
              <FontAwesomeIcon icon={faUsers} />{" "}
              <span className="text">Program Page</span>
            </NavLink>
          )}

          {(!isInCrew || progamFinished || me?.admin) && (
            <span
              onClick={() => {
                setShowLearn(!showLearn);
              }}
              className="link"
            >
              <div className={`item ${pathName.includes("/learn/")}`}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.96733 13.9333L2.74066 13.3333C2.56344 12.973 2.31112 12.6547 2.00066 12.4C1.82255 12.2614 1.61499 12.1656 1.394 12.12C1.434 11.5333 1.474 10.86 1.48066 10.2066C1.48066 9.69332 1.48066 9.19332 1.42733 8.75332C1.354 8.20665 1.30066 7.64665 1.18733 7.09998C1.10545 6.72108 0.982498 6.35223 0.820662 5.99998C0.812477 5.97507 0.799311 5.95209 0.781963 5.93242C0.764615 5.91276 0.743449 5.89683 0.719752 5.88561C0.696055 5.87438 0.670322 5.8681 0.644119 5.86713C0.617915 5.86616 0.591789 5.87053 0.567329 5.87998C0.542418 5.88817 0.519432 5.90133 0.49977 5.91868C0.480107 5.93603 0.464179 5.9572 0.452954 5.98089C0.441729 6.00459 0.435442 6.03032 0.434475 6.05653C0.433508 6.08273 0.437881 6.10886 0.447329 6.13332C0.534102 6.47401 0.587685 6.8223 0.607329 7.17332C0.653996 7.71998 0.607329 8.26665 0.653996 8.80665L0.887329 12.14C0.694365 12.2059 0.522036 12.3212 0.387519 12.4744C0.253001 12.6276 0.160992 12.8134 0.120662 13.0133C-0.0193874 13.8296 -0.0193874 14.6637 0.120662 15.48C0.122363 15.5098 0.129925 15.5389 0.142917 15.5658C0.155909 15.5926 0.174074 15.6167 0.196371 15.6365C0.218668 15.6563 0.244658 15.6715 0.272851 15.6813C0.301044 15.691 0.330885 15.6951 0.360662 15.6933C0.406738 15.6866 0.450338 15.6683 0.487329 15.64C0.727329 15.64 0.953996 15.6066 1.154 15.6066C1.354 15.6066 1.654 15.6066 1.894 15.6066C2.17099 15.6234 2.44899 15.6032 2.72066 15.5466C2.8507 15.5149 2.96597 15.4396 3.04733 15.3333C3.10715 15.1669 3.12769 14.989 3.10733 14.8133C3.08824 14.5163 3.04137 14.2216 2.96733 13.9333ZM1.874 15.06L0.540662 15.2267C0.516388 14.6481 0.55889 14.0688 0.667329 13.5C0.747329 13.14 0.847329 12.8333 1.14733 12.8333C1.34061 12.8533 1.51804 12.9492 1.64066 13.1C1.81698 13.2648 1.96357 13.4587 2.074 13.6733L2.274 14.1733C2.35658 14.4112 2.41466 14.6569 2.44733 14.9067C2.28733 14.8933 2.00066 15.0466 1.874 15.06ZM2.44733 15.06C2.44733 15.06 2.44733 15.04 2.44733 15.0333V15.06Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9999 4.33998C15.9478 4.1982 15.8491 4.07832 15.7199 3.99998C15.4731 3.82891 15.2147 3.67521 14.9466 3.53998C14.5333 3.27331 14.0866 3.01998 13.6133 2.77331C12.9466 2.41331 12.2799 2.10665 11.6133 1.75331L9.33326 0.666647C9.11962 0.546707 8.89668 0.444154 8.66659 0.359981C8.5303 0.320632 8.38786 0.307066 8.24659 0.319981C8.16093 0.330838 8.07761 0.355608 7.99993 0.393314C7.89326 0.453314 7.78659 0.539981 7.71326 0.579981L6.37993 1.24665C5.67326 1.57998 4.97993 1.95331 4.29993 2.33998C3.61993 2.72665 2.96659 3.13998 2.29993 3.55331L0.299926 4.88665C0.255701 4.91654 0.224757 4.96238 0.213573 5.01457C0.202388 5.06676 0.211832 5.12126 0.239926 5.16665C0.270827 5.20978 0.317136 5.23938 0.369261 5.24931C0.421385 5.25924 0.475331 5.24874 0.519926 5.21998L2.50659 3.93998C3.17326 3.55331 3.83993 3.16665 4.50659 2.79998C5.17326 2.43331 5.89326 2.09331 6.59993 1.78665L7.93326 1.11998L8.25993 0.926647C8.34304 0.924986 8.42534 0.943275 8.49993 0.979981C8.69326 1.05331 8.87326 1.17331 9.01326 1.23998L11.2666 2.35998C11.9333 2.68665 12.5999 3.02665 13.2666 3.38665C13.6999 3.62665 14.1266 3.87331 14.5266 4.13331C14.6399 4.19998 15.0599 4.31998 15.2266 4.43331C15.1432 4.51921 15.0541 4.59939 14.9599 4.67331C14.6866 4.85998 14.3666 5.02665 14.2066 5.12665C13.6466 5.48665 13.0866 5.85331 12.5533 6.23998C12.0199 6.62665 11.4733 7.03331 10.9599 7.43998L9.62659 8.35331C9.43647 8.36394 9.24613 8.33674 9.06659 8.27331C8.53326 8.11331 7.95326 7.80665 7.54659 7.68665C7.13993 7.56665 6.57326 7.39998 6.06659 7.21998C5.55993 7.03998 5.07993 6.87998 4.66659 6.66665L3.07993 5.92665C2.75326 5.77998 2.41326 5.62665 1.99993 5.45998C1.79326 5.37998 1.57326 5.24665 1.33326 5.14665C1.22779 5.0979 1.11854 5.05777 1.00659 5.02665C0.978132 5.01865 0.948352 5.01647 0.919031 5.02024C0.88971 5.02401 0.861448 5.03365 0.835936 5.04858C0.810423 5.06352 0.788181 5.08344 0.77054 5.10716C0.752899 5.13088 0.740219 5.15792 0.733259 5.18665C0.725191 5.21554 0.722939 5.24575 0.726631 5.27551C0.730324 5.30528 0.739889 5.33402 0.754772 5.36007C0.769655 5.38611 0.78956 5.40895 0.813332 5.42724C0.837104 5.44554 0.864272 5.45893 0.893259 5.46665L1.79326 5.89998C2.19993 6.07331 2.52659 6.22665 2.84659 6.37998L3.51326 6.69998L3.63993 9.81331C3.60704 10.1458 3.60704 10.4808 3.63993 10.8133C3.67725 10.9953 3.75979 11.165 3.87993 11.3066C4.37718 11.9105 5.01941 12.3784 5.74659 12.6666C6.44172 12.9286 7.17191 13.0859 7.91326 13.1333C8.893 13.1452 9.8674 12.9873 10.7933 12.6666C11.4814 12.5034 12.114 12.1607 12.6266 11.6733C12.7179 11.4826 12.7743 11.2772 12.7933 11.0666C12.8079 10.7957 12.8079 10.5242 12.7933 10.2533C12.7933 9.87998 12.7933 9.28665 12.7266 8.68665C12.6599 8.08665 12.6399 7.50665 12.5799 7.13998L12.9533 6.87331C13.4866 6.49998 14.0266 6.13998 14.5799 5.79998C15.0191 5.58108 15.429 5.30782 15.7999 4.98665C15.8842 4.90385 15.9466 4.80142 15.9815 4.68855C16.0164 4.57568 16.0227 4.4559 15.9999 4.33998ZM12.2666 8.71331C12.2666 9.29998 12.2666 9.88665 12.2666 10.2533C12.2595 10.4986 12.2395 10.7434 12.2066 10.9866C12.1896 11.1207 12.1513 11.2513 12.0933 11.3733C12.0933 11.42 11.9666 11.46 11.8533 11.52C11.3188 11.7733 10.7575 11.9656 10.1799 12.0933C9.46997 12.2856 8.7349 12.3688 7.99993 12.34C7.31832 12.3017 6.64528 12.1693 5.99993 11.9466C5.38148 11.7328 4.82197 11.3766 4.36659 10.9066C4.28852 10.8167 4.23969 10.7051 4.22659 10.5866C4.19733 10.3322 4.18397 10.0761 4.18659 9.81998L3.91993 6.91331L4.41326 7.16665C4.76659 7.33998 5.16659 7.51331 5.58659 7.67998C6.19326 7.91331 6.83326 8.13331 7.38659 8.30665C7.78659 8.42665 8.35993 8.74665 8.88659 8.91998C9.147 9.01427 9.42318 9.05729 9.69993 9.04665C9.8654 9.00603 10.0231 8.93846 10.1666 8.84665C10.5599 8.61331 11.1666 8.17998 11.3933 8.02665C11.6199 7.87331 11.9199 7.63998 12.1799 7.45331C12.2133 7.79998 12.2333 8.25998 12.2466 8.71331H12.2666Z"
                    fill="white"
                  />
                </svg>
                <span className="text">
                  Learn {showLearn && <FontAwesomeIcon icon={faChevronUp} />}{" "}
                </span>
                {!showLearn && <FontAwesomeIcon icon={faChevronDown} />}
              </div>
              {showLearn && (
                <div className="dropdown">
                  <ul>
                    <li
                      className={`${pathName.includes("learn/paths")}`}
                      onClick={() => {
                        history.push("/learn/paths");
                      }}
                    >
                      <div className="line"></div>Learning Paths
                    </li>
                    <li
                      className={`${pathName.includes("learn/activities")}`}
                      onClick={() => {
                        history.push("/learn/activities");
                      }}
                    >
                      Activities
                    </li>
                  </ul>
                </div>
              )}
            </span>
          )}

          {isInCrew && !progamFinished && !me?.admin && (
            <span
              onClick={() => {
                setShowLearn(!showLearn);
              }}
              className="link disabled"
            >
              <div className={`item ${pathName.includes("/learn/")}`}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.96733 13.9333L2.74066 13.3333C2.56344 12.973 2.31112 12.6547 2.00066 12.4C1.82255 12.2614 1.61499 12.1656 1.394 12.12C1.434 11.5333 1.474 10.86 1.48066 10.2066C1.48066 9.69332 1.48066 9.19332 1.42733 8.75332C1.354 8.20665 1.30066 7.64665 1.18733 7.09998C1.10545 6.72108 0.982498 6.35223 0.820662 5.99998C0.812477 5.97507 0.799311 5.95209 0.781963 5.93242C0.764615 5.91276 0.743449 5.89683 0.719752 5.88561C0.696055 5.87438 0.670322 5.8681 0.644119 5.86713C0.617915 5.86616 0.591789 5.87053 0.567329 5.87998C0.542418 5.88817 0.519432 5.90133 0.49977 5.91868C0.480107 5.93603 0.464179 5.9572 0.452954 5.98089C0.441729 6.00459 0.435442 6.03032 0.434475 6.05653C0.433508 6.08273 0.437881 6.10886 0.447329 6.13332C0.534102 6.47401 0.587685 6.8223 0.607329 7.17332C0.653996 7.71998 0.607329 8.26665 0.653996 8.80665L0.887329 12.14C0.694365 12.2059 0.522036 12.3212 0.387519 12.4744C0.253001 12.6276 0.160992 12.8134 0.120662 13.0133C-0.0193874 13.8296 -0.0193874 14.6637 0.120662 15.48C0.122363 15.5098 0.129925 15.5389 0.142917 15.5658C0.155909 15.5926 0.174074 15.6167 0.196371 15.6365C0.218668 15.6563 0.244658 15.6715 0.272851 15.6813C0.301044 15.691 0.330885 15.6951 0.360662 15.6933C0.406738 15.6866 0.450338 15.6683 0.487329 15.64C0.727329 15.64 0.953996 15.6066 1.154 15.6066C1.354 15.6066 1.654 15.6066 1.894 15.6066C2.17099 15.6234 2.44899 15.6032 2.72066 15.5466C2.8507 15.5149 2.96597 15.4396 3.04733 15.3333C3.10715 15.1669 3.12769 14.989 3.10733 14.8133C3.08824 14.5163 3.04137 14.2216 2.96733 13.9333ZM1.874 15.06L0.540662 15.2267C0.516388 14.6481 0.55889 14.0688 0.667329 13.5C0.747329 13.14 0.847329 12.8333 1.14733 12.8333C1.34061 12.8533 1.51804 12.9492 1.64066 13.1C1.81698 13.2648 1.96357 13.4587 2.074 13.6733L2.274 14.1733C2.35658 14.4112 2.41466 14.6569 2.44733 14.9067C2.28733 14.8933 2.00066 15.0466 1.874 15.06ZM2.44733 15.06C2.44733 15.06 2.44733 15.04 2.44733 15.0333V15.06Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9999 4.33998C15.9478 4.1982 15.8491 4.07832 15.7199 3.99998C15.4731 3.82891 15.2147 3.67521 14.9466 3.53998C14.5333 3.27331 14.0866 3.01998 13.6133 2.77331C12.9466 2.41331 12.2799 2.10665 11.6133 1.75331L9.33326 0.666647C9.11962 0.546707 8.89668 0.444154 8.66659 0.359981C8.5303 0.320632 8.38786 0.307066 8.24659 0.319981C8.16093 0.330838 8.07761 0.355608 7.99993 0.393314C7.89326 0.453314 7.78659 0.539981 7.71326 0.579981L6.37993 1.24665C5.67326 1.57998 4.97993 1.95331 4.29993 2.33998C3.61993 2.72665 2.96659 3.13998 2.29993 3.55331L0.299926 4.88665C0.255701 4.91654 0.224757 4.96238 0.213573 5.01457C0.202388 5.06676 0.211832 5.12126 0.239926 5.16665C0.270827 5.20978 0.317136 5.23938 0.369261 5.24931C0.421385 5.25924 0.475331 5.24874 0.519926 5.21998L2.50659 3.93998C3.17326 3.55331 3.83993 3.16665 4.50659 2.79998C5.17326 2.43331 5.89326 2.09331 6.59993 1.78665L7.93326 1.11998L8.25993 0.926647C8.34304 0.924986 8.42534 0.943275 8.49993 0.979981C8.69326 1.05331 8.87326 1.17331 9.01326 1.23998L11.2666 2.35998C11.9333 2.68665 12.5999 3.02665 13.2666 3.38665C13.6999 3.62665 14.1266 3.87331 14.5266 4.13331C14.6399 4.19998 15.0599 4.31998 15.2266 4.43331C15.1432 4.51921 15.0541 4.59939 14.9599 4.67331C14.6866 4.85998 14.3666 5.02665 14.2066 5.12665C13.6466 5.48665 13.0866 5.85331 12.5533 6.23998C12.0199 6.62665 11.4733 7.03331 10.9599 7.43998L9.62659 8.35331C9.43647 8.36394 9.24613 8.33674 9.06659 8.27331C8.53326 8.11331 7.95326 7.80665 7.54659 7.68665C7.13993 7.56665 6.57326 7.39998 6.06659 7.21998C5.55993 7.03998 5.07993 6.87998 4.66659 6.66665L3.07993 5.92665C2.75326 5.77998 2.41326 5.62665 1.99993 5.45998C1.79326 5.37998 1.57326 5.24665 1.33326 5.14665C1.22779 5.0979 1.11854 5.05777 1.00659 5.02665C0.978132 5.01865 0.948352 5.01647 0.919031 5.02024C0.88971 5.02401 0.861448 5.03365 0.835936 5.04858C0.810423 5.06352 0.788181 5.08344 0.77054 5.10716C0.752899 5.13088 0.740219 5.15792 0.733259 5.18665C0.725191 5.21554 0.722939 5.24575 0.726631 5.27551C0.730324 5.30528 0.739889 5.33402 0.754772 5.36007C0.769655 5.38611 0.78956 5.40895 0.813332 5.42724C0.837104 5.44554 0.864272 5.45893 0.893259 5.46665L1.79326 5.89998C2.19993 6.07331 2.52659 6.22665 2.84659 6.37998L3.51326 6.69998L3.63993 9.81331C3.60704 10.1458 3.60704 10.4808 3.63993 10.8133C3.67725 10.9953 3.75979 11.165 3.87993 11.3066C4.37718 11.9105 5.01941 12.3784 5.74659 12.6666C6.44172 12.9286 7.17191 13.0859 7.91326 13.1333C8.893 13.1452 9.8674 12.9873 10.7933 12.6666C11.4814 12.5034 12.114 12.1607 12.6266 11.6733C12.7179 11.4826 12.7743 11.2772 12.7933 11.0666C12.8079 10.7957 12.8079 10.5242 12.7933 10.2533C12.7933 9.87998 12.7933 9.28665 12.7266 8.68665C12.6599 8.08665 12.6399 7.50665 12.5799 7.13998L12.9533 6.87331C13.4866 6.49998 14.0266 6.13998 14.5799 5.79998C15.0191 5.58108 15.429 5.30782 15.7999 4.98665C15.8842 4.90385 15.9466 4.80142 15.9815 4.68855C16.0164 4.57568 16.0227 4.4559 15.9999 4.33998ZM12.2666 8.71331C12.2666 9.29998 12.2666 9.88665 12.2666 10.2533C12.2595 10.4986 12.2395 10.7434 12.2066 10.9866C12.1896 11.1207 12.1513 11.2513 12.0933 11.3733C12.0933 11.42 11.9666 11.46 11.8533 11.52C11.3188 11.7733 10.7575 11.9656 10.1799 12.0933C9.46997 12.2856 8.7349 12.3688 7.99993 12.34C7.31832 12.3017 6.64528 12.1693 5.99993 11.9466C5.38148 11.7328 4.82197 11.3766 4.36659 10.9066C4.28852 10.8167 4.23969 10.7051 4.22659 10.5866C4.19733 10.3322 4.18397 10.0761 4.18659 9.81998L3.91993 6.91331L4.41326 7.16665C4.76659 7.33998 5.16659 7.51331 5.58659 7.67998C6.19326 7.91331 6.83326 8.13331 7.38659 8.30665C7.78659 8.42665 8.35993 8.74665 8.88659 8.91998C9.147 9.01427 9.42318 9.05729 9.69993 9.04665C9.8654 9.00603 10.0231 8.93846 10.1666 8.84665C10.5599 8.61331 11.1666 8.17998 11.3933 8.02665C11.6199 7.87331 11.9199 7.63998 12.1799 7.45331C12.2133 7.79998 12.2333 8.25998 12.2466 8.71331H12.2666Z"
                    fill="white"
                  />
                </svg>
                <span className="text">
                  Learn {showLearn && <FontAwesomeIcon icon={faChevronUp} />}{" "}
                </span>
                {!showLearn && <FontAwesomeIcon icon={faChevronDown} />}
              </div>
              {showLearn && (
                <div className="dropdown">
                  <ul>
                    <li
                      className={`${pathName.includes("learn/paths")}`}
                      onClick={() => {}}
                    >
                      <div className="line"></div>Learning Paths
                    </li>
                    <li
                      className={`${pathName.includes("learn/activities")}`}
                      onClick={() => {}}
                    >
                      Activities
                    </li>
                  </ul>
                </div>
              )}
            </span>
          )}

          {(isCoach || me?.admin) && (
            <NavLink
              isActive={() => {
                if (pathName.includes("coaching")) {
                  return true;
                }
                return false;
              }}
              className="link"
              to="/coaching"
            >
              <FontAwesomeIcon icon={faPencil} />{" "}
              <span className="text">Coaching</span>
            </NavLink>
          )}

          {(!isInCrew || me?.admin) && (
            <NavLink
              isActive={() => {
                if (pathName.includes("storyboard")) {
                  return true;
                }
                return false;
              }}
              className="link"
              to="/storyboard"
            >
              <FontAwesomeIcon icon={faComment} />{" "}
              <span className="text">Stories Inbox</span>
            </NavLink>
          )}
          {/* <a
            rel="no-referrer"
            style={{
              opacity: 0.3,
            }}
            className="link canvas"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_293_363)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.85394 2.13333C6.80135 2.01071 6.73892 1.89254 6.66727 1.77999C6.63172 1.73872 6.58319 1.71076 6.52965 1.70072C6.47611 1.69068 6.42074 1.69916 6.37266 1.72475C6.32457 1.75035 6.28662 1.79154 6.26504 1.84156C6.24347 1.89158 6.23955 1.94745 6.25394 1.99999L6.48727 2.66666C6.63394 3.30113 6.54338 3.96733 6.23267 4.53963C5.92197 5.11192 5.41258 5.55074 4.80061 5.77333C4.21807 6.05479 3.55688 6.12891 2.92648 5.98344C2.29607 5.83796 1.73423 5.4816 1.33394 4.97333C1.10985 4.67906 0.955587 4.33769 0.882825 3.97504C0.810064 3.61238 0.820703 3.23793 0.91394 2.87999C1.0007 2.5045 1.16385 2.15089 1.39325 1.84121C1.62264 1.53153 1.91336 1.27241 2.24727 1.07999C2.74678 0.779203 3.32505 0.635217 3.90727 0.66666C4.50492 0.707469 5.08372 0.892777 5.59394 1.20666C5.61745 1.22282 5.64396 1.2341 5.6719 1.23983C5.69984 1.24556 5.72865 1.24563 5.75662 1.24004C5.78459 1.23445 5.81115 1.2233 5.83474 1.20726C5.85832 1.19122 5.87846 1.17061 5.89394 1.14666C5.92418 1.09785 5.93413 1.03914 5.92167 0.98309C5.90922 0.927037 5.87534 0.878075 5.82727 0.84666C5.26634 0.472016 4.62411 0.23661 3.95394 0.159993C3.26704 0.0787087 2.57141 0.201603 1.95394 0.513327C1.52581 0.730524 1.14726 1.03395 0.842071 1.40453C0.536887 1.77511 0.311679 2.20483 0.180607 2.66666C0.046097 3.14166 0.0242673 3.64149 0.116853 4.12641C0.209439 4.61133 0.413887 5.06796 0.71394 5.45999C1.22542 6.09498 1.93798 6.53675 2.73419 6.71247C3.53039 6.8882 4.36271 6.78739 5.09394 6.42666C5.83616 6.12019 6.4395 5.55108 6.78874 4.828C7.13798 4.10492 7.20866 3.27854 6.98727 2.50666C6.94984 2.37982 6.90532 2.25518 6.85394 2.13333Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.2472 6.05333C10.5127 6.22895 10.7994 6.37008 11.1005 6.47333C11.1624 6.49278 11.2295 6.48771 11.2878 6.45918C11.3461 6.43065 11.3912 6.38083 11.4138 6.31999C11.4254 6.28896 11.4306 6.25591 11.429 6.22283C11.4275 6.18976 11.4194 6.15732 11.4051 6.12746C11.3908 6.09759 11.3706 6.07092 11.3458 6.04902C11.3209 6.02712 11.2919 6.01045 11.2605 5.99999C10.7547 5.81859 10.3155 5.48862 10.0005 5.05333C9.77421 4.74215 9.62278 4.38294 9.55803 4.00367C9.49328 3.6244 9.51694 3.23529 9.62718 2.86666C9.73034 2.50032 9.9071 2.15886 10.1467 1.86313C10.3862 1.5674 10.6836 1.32361 11.0205 1.14666C11.5899 0.849775 12.2421 0.751245 12.8738 0.866661C13.498 0.952694 14.0826 1.22181 14.5538 1.63999C14.6808 1.79319 14.7924 1.95842 14.8872 2.13333C14.983 2.29945 15.0591 2.4762 15.1138 2.65999C15.2364 3.05683 15.2597 3.47765 15.1819 3.88561C15.104 4.29356 14.9273 4.6762 14.6672 4.99999C14.3925 5.33472 14.0544 5.61186 13.6723 5.81551C13.2901 6.01916 12.8715 6.14529 12.4405 6.18666C12.4124 6.18917 12.3852 6.19721 12.3602 6.21032C12.3353 6.22343 12.3132 6.24134 12.2952 6.26304C12.2772 6.28473 12.2637 6.30977 12.2555 6.33671C12.2473 6.36365 12.2444 6.39196 12.2472 6.41999C12.2488 6.44776 12.2561 6.47491 12.2685 6.49981C12.2809 6.52471 12.2982 6.54685 12.3194 6.56491C12.3405 6.58296 12.3651 6.59655 12.3917 6.60487C12.4182 6.61319 12.4462 6.61607 12.4738 6.61333C12.9784 6.59381 13.4739 6.47413 13.9318 6.26124C14.3896 6.04836 14.8005 5.74653 15.1405 5.37333C15.4839 4.98446 15.7271 4.51764 15.8491 4.01342C15.9711 3.5092 15.9682 2.98282 15.8405 2.47999C15.782 2.23288 15.6947 1.99348 15.5805 1.76666C15.4726 1.54614 15.3407 1.33821 15.1872 1.14666C14.5958 0.558925 13.8319 0.175806 13.0072 0.0533274C12.2051 -0.0827093 11.3807 0.0558781 10.6672 0.446661C10.2477 0.681569 9.88054 0.99962 9.58823 1.38134C9.29592 1.76307 9.08459 2.20043 8.96718 2.66666C8.84844 3.13242 8.83963 3.6194 8.94144 4.08915C9.04326 4.5589 9.25291 4.99853 9.55384 5.37333C9.75088 5.63231 9.98442 5.86136 10.2472 6.05333Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.76063 11.1067C6.65068 10.8923 6.5236 10.6872 6.38063 10.4933C5.80889 9.91176 5.07026 9.52264 4.26729 9.37999C3.46113 9.22769 2.62715 9.3522 1.90063 9.73333C1.471 9.97116 1.09522 10.2953 0.796925 10.6854C0.498627 11.0755 0.284257 11.5231 0.167294 12C0.0445471 12.474 0.0336499 12.9701 0.135462 13.4491C0.237275 13.9281 0.44901 14.3769 0.75396 14.76C1.04457 15.1219 1.40756 15.4192 1.8197 15.6327C2.23183 15.8462 2.68402 15.9713 3.14729 16C4.05451 16.0585 4.95346 15.7966 5.68729 15.26C5.714 15.242 5.73682 15.2188 5.75437 15.1918C5.77192 15.1647 5.78385 15.1345 5.78945 15.1027C5.79504 15.071 5.7942 15.0385 5.78696 15.0071C5.77971 14.9757 5.76623 14.9461 5.74729 14.92C5.70871 14.8689 5.65218 14.8342 5.5891 14.8231C5.52601 14.812 5.46105 14.8252 5.40729 14.86C4.75852 15.2952 3.97752 15.4886 3.20063 15.4067C2.82983 15.3641 2.47209 15.2443 2.15054 15.0548C1.82899 14.8653 1.5508 14.6104 1.33396 14.3067C1.1134 14.0043 0.965571 13.655 0.901976 13.2862C0.838381 12.9173 0.860734 12.5388 0.967294 12.18C1.06163 11.8172 1.22838 11.4771 1.45752 11.1804C1.68665 10.8837 1.97344 10.6364 2.30063 10.4533C2.86543 10.1429 3.51706 10.028 4.15396 10.1267C4.79704 10.2044 5.4026 10.4712 5.89396 10.8933C6.02294 11.0479 6.13889 11.2129 6.24063 11.3867C6.34084 11.5593 6.42134 11.7427 6.48063 11.9333C6.58462 12.2901 6.61858 12.6636 6.58063 13.0333C6.53786 13.4021 6.41499 13.757 6.22063 14.0733C6.19974 14.1214 6.19668 14.1753 6.21202 14.2254C6.22735 14.2755 6.26007 14.3185 6.30427 14.3466C6.34848 14.3748 6.40128 14.3862 6.45316 14.3789C6.50505 14.3715 6.55261 14.3459 6.58729 14.3067C6.83328 13.9442 6.9971 13.5324 7.06729 13.1C7.13407 12.6676 7.11823 12.2265 7.02063 11.8C6.96235 11.5592 6.87504 11.3264 6.76063 11.1067Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.8472 11.7733C15.7886 11.5262 15.7014 11.2868 15.5872 11.06C15.4743 10.8408 15.3404 10.6331 15.1872 10.44C14.5965 9.8489 13.8329 9.46128 13.0072 9.33333C12.2001 9.1946 11.3698 9.33572 10.6538 9.73333C10.2333 9.97491 9.86753 10.3011 9.57951 10.6912C9.29149 11.0814 9.08753 11.527 8.9805 12C8.86579 12.4592 8.85845 12.9386 8.95904 13.4011C9.05962 13.8635 9.26544 14.2966 9.5605 14.6667C9.70557 14.8472 9.86863 15.0125 10.0472 15.16C10.2246 15.3095 10.4193 15.437 10.6272 15.54C10.6552 15.5549 10.6859 15.5641 10.7174 15.5671C10.749 15.5702 10.7809 15.5669 10.8112 15.5577C10.8415 15.5484 10.8698 15.5332 10.8942 15.513C10.9187 15.4928 10.939 15.468 10.9538 15.44C10.9687 15.412 10.9779 15.3813 10.981 15.3497C10.984 15.3182 10.9808 15.2863 10.9715 15.256C10.9622 15.2256 10.947 15.1974 10.9268 15.1729C10.9067 15.1485 10.8819 15.1282 10.8538 15.1133C10.6837 15.0183 10.5249 14.9042 10.3805 14.7733C10.2359 14.6417 10.1042 14.4966 9.98717 14.34C9.76132 14.026 9.61078 13.6643 9.54719 13.2828C9.48361 12.9013 9.50869 12.5102 9.6205 12.14C9.72249 11.7723 9.89874 11.4294 10.1384 11.1324C10.378 10.8354 10.676 10.5907 11.0138 10.4133C11.5864 10.1187 12.2407 10.0226 12.8738 10.14C13.4973 10.2303 14.0798 10.5041 14.5472 10.9267C14.674 11.0775 14.7857 11.2405 14.8805 11.4133C14.9742 11.5797 15.048 11.7564 15.1005 11.94C15.2361 12.3742 15.2531 12.8368 15.15 13.2798C15.0469 13.7228 14.8272 14.1303 14.5138 14.46C14.182 14.8 13.7813 15.0651 13.3386 15.2375C12.896 15.41 12.4215 15.4858 11.9472 15.46C11.9191 15.4572 11.8908 15.4601 11.8639 15.4683C11.8369 15.4766 11.8119 15.4901 11.7902 15.508C11.7685 15.526 11.7506 15.5481 11.7375 15.573C11.7244 15.598 11.7163 15.6253 11.7138 15.6533C11.7101 15.6815 11.7123 15.7102 11.7201 15.7375C11.728 15.7649 11.7414 15.7903 11.7596 15.8122C11.7777 15.8341 11.8002 15.852 11.8256 15.8648C11.851 15.8776 11.8788 15.8851 11.9072 15.8867C12.4543 15.9455 13.0078 15.8861 13.53 15.7125C14.0522 15.5388 14.5309 15.2549 14.9338 14.88C15.3492 14.4906 15.6529 13.9972 15.8135 13.451C15.9741 12.9048 15.9857 12.3256 15.8472 11.7733Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_293_363">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Canvas <span>Coming Soon</span>
          </a> */}
          {me?.admin && (
            <NavLink to="/admin" className="link">
              <FontAwesomeIcon icon={faUser} />{" "}
              <span className="text">Admin</span>
            </NavLink>
          )}
        </div>

        <ProfileDropdown />
      </nav>
    </div>
  );
};
